import React from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';

import {
    fetchBlogPages,
    fetchFeaturedArticle,
    searchBlogs,
    fetchArticleArchives,
    fetchTags,
    createMetaText,
} from '../blog-list-actions';
import { doSearch } from '../../search-filter/search-filter-actions';
import { Helpers } from '../../core/src/helpers';
import BlogAdSenseScript from './ads/adsense/adsense-script';

const BlogList = loadable(() => import('./blog-list'));
const BlogListV2 = loadable(() => import('../components-v2/blog-list'));

const mapDispatchToProps = dispatch => {
    return {
        fetchFeaturedArticle: (query, slugInfo) => dispatch(fetchFeaturedArticle(query, slugInfo)),
        fetchBlogPages: (filters, post_filters, aggregates, aggregateFilters, sort, size, from, query, bucketSize) =>
            dispatch(
                fetchBlogPages(filters, post_filters, aggregates, aggregateFilters, sort, size, from, query, bucketSize)
            ),
    };
};

const mapStateToProps = (state, ownProps) => {
    const {filters} = ownProps.match.params;
    const { siteConfig ={}, userData } = state;
    const { blog } = siteConfig || {};
    const { domain } = blog || {};
    const { originCountryCode } = userData || {};
    let title = "Consumer and Business Technology Trends | HP® Tech Takes";
    let description = "Find out about the latest in Consumer and Business Technology Trends on HP® Tech Takes. Exploring today's technology for tomorrow's possibilities.";
    let canonicalDomain = domain ? `https://${domain}` : 'https://www.hp.com';
    let canonical = `${ canonicalDomain }${siteConfig.basename}/tech-takes`;

    if(filters) {
        const filtersObj = Helpers.parseFilters(filters);
        const {titleMetaText, description:generatedDescription} = createMetaText(filtersObj.query);
        const { router={location : { pathname : ""} } }  = state;
        title = titleMetaText + "HP® Tech Takes";
        description = generatedDescription;
        canonical = canonicalDomain  + state.router.location.pathname;
    }

    return {
        title,
        description,
        canonical,
        featuredArticle: state.blogListInfo.featuredArticle,
        blogHits: state.blogListInfo.blogHits,
        testFlags: state.testFlags,
        //TODO: site config shouldn't have template specific settings. It should only have universal page settings
        //we may want to considering storing this as part of the template and bringing it in along with the page components
        blogConfig: siteConfig.blog,
        originCountryCode
    }
}


const BlogListContainer = (props) => {
    let { testFlags } = props;
    let { ssrTest } = testFlags || {};
    let { uxRedesign } = ssrTest || {};

    return (
        <React.Fragment>
        <BlogAdSenseScript />
        {
            uxRedesign && uxRedesign.variation && uxRedesign.variation.toLowerCase() === 'variation'
            ? <BlogListV2 {...props}/>
            : <BlogList   {...props}/>
        }
        </React.Fragment>
    );
}
  
  
  
const loadData = async (urlParams, store, query) => {
  
    const featuredArticleQuery = {
      templateKey: 'blog',
      featured: 'true',
      limit: '1',
      hosted: 'true',
      sort: '-updatedAt'
    };
  
    let slug = "tech-takes";
  
  
    let filters = {templateKey: 'blog', hosted: 'true', blogArchive: 'false'};
    let post_filters = {};
    let sort = {"blogDate": "desc"};
    let size = 14;
  
    const filterParams = urlParams.filters;
  
    if(filterParams) {
        const additionalFilters = Helpers.parseFilters(filterParams);

        const query = additionalFilters.query;
        if(query.size) {
            size = parseInt(query.size[0]);
            delete query.size;
        }
        if(query.sort) {
            sort = query.sort[0];
            delete query.sort;
        }
        post_filters = { ...query };
    }

    const filtersArticleArchives = { templateKey: 'blog', hosted: 'true', blogArchive: 'true' };
    const aggregates = {
        all_years: 'year',
        all_months: 'month',
        all_categories: 'categories',
    };

    const bucketSize = 30;

    const sortTopBlogs = { visitCount: 'desc' };
    const sizeTopBlogs = 10;

    const filtersTopTags = { templateKey: 'blog', hosted: 'true', blogArchive: 'false' };
    const aggregatesTopTags = { tags: 'tags' };
    const aggregateFiltersTopTags = Object.keys(aggregatesTopTags);
    const bucketSizeTopTags = 10;

    const aggregateFilters = Object.keys(aggregates);
    const from = 0;

    const promise = await store.dispatch(
        fetchBlogPages(filters, post_filters, aggregates, aggregateFilters, sort, size, from, {}, bucketSize)
    );

    const storeData = store.getState();
    const { blogListInfo = {} } = storeData;
    const { blogHits } = blogListInfo;
    const needRedirect = blogHits && blogHits.hits.total === 0 && filterParams;
    const destination = storeData.redirects.destination || '/tech-takes';
    if (needRedirect) return Promise.resolve({ status: 301, destination });

    return Promise.all([
        store.dispatch(fetchFeaturedArticle(featuredArticleQuery, { vanityUrl: slug })),
        store.dispatch(
            fetchBlogPages(filters, post_filters, aggregates, aggregateFilters, sort, size, from, {}, bucketSize)
        ),
        store.dispatch(
            doSearch('topBlogs', () =>
                searchBlogs(
                    filters,
                    post_filters,
                    aggregates,
                    aggregateFilters,
                    sortTopBlogs,
                    sizeTopBlogs,
                    from,
                    bucketSize
                )
            )
        ),
        store.dispatch(
            fetchArticleArchives(filtersArticleArchives, {}, aggregates, aggregateFilters, sort, size, from, bucketSize)
        ),
        store.dispatch(
            fetchTags(filtersTopTags, {}, aggregatesTopTags, aggregateFiltersTopTags, null, 0, from, bucketSizeTopTags)
        ),
    ]);
};

export default {
    component: connect(mapStateToProps, mapDispatchToProps)(BlogListContainer),
    loadData,
};
